import styled from "@emotion/styled";
import type { ReactNode, CSSProperties, Ref } from "react";
import React from "react";

export interface FlexCenterProps {
  children?: ReactNode;
  maxWidth?: string;
  textAlign?: boolean;
  className?: string;
  style?: CSSProperties;
  "data-testid"?: string;
  ref?: Ref<HTMLDivElement>;
}

const Container = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  min-height: 100%;
  box-sizing: border-box;

  &[data-text-center="true"] {
    text-align: center;
  }
`;

const FlexCenter = ({
  children,
  textAlign = false,
  className,
  style,
  "data-testid": dataTestId,
  ref
}: FlexCenterProps) => {
  return (
    <Container
      ref={ref}
      className={className}
      style={style}
      data-text-center={textAlign ? "true" : undefined}
      data-testid={dataTestId}
    >
      {children}
    </Container>
  );
};

export default FlexCenter;
